import "core-js/stable"
import "regenerator-runtime/runtime"

require("@rails/ujs").start()

import { Card } from "../src/js/objects/card"
import { Alert, Button } from "bootstrap"

let ready = () => {
  const card = new Card($, document)
  card.logCardClicks()
  card.verifyClickCollect()
  card.unblur()
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("readysir")
  ready()
})

import { Application } from "@hotwired/stimulus"
import AvatarVisualisationController from "./controllers/application/avatar_visualisation_controller"
window.Stimulus = Application.start()
Stimulus.register("avatar-visualisation", AvatarVisualisationController)
